import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Card, CardActionArea, CardContent, Grow } from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles({
  root: {
    textAlign: "left",
  },
});

const CardPost = ({ headerText, bodyText, postExcerpt, date, onClick }) => {
  const classes = useStyles();
  const [hover, setHover] = useState(false);

  return (
    <Grow in={true} timeout={1000}>
      <Card
        className={classes.root}
        elevation={hover ? 3 : 2}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <CardActionArea onClick={onClick}>
          <CardContent>
            <Typography variant="body2" color="primary">
              {moment(date).format("LLL")}
            </Typography>
            <Typography
              variant="h6"
              color="textPrimary"
              dangerouslySetInnerHTML={{ __html: headerText }}
            ></Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              dangerouslySetInnerHTML={{
                __html: bodyText.length > 253 ? postExcerpt : bodyText,
              }}
            />
            {bodyText.length > 253 && (
              <Typography
                variant="subtitle2"
                color={hover ? "primary" : "textPrimary"}
                style={{ textTransform: "uppercase" }}
              >
                {window.t["Read More"]}
              </Typography>
            )}
          </CardContent>
        </CardActionArea>
      </Card>
    </Grow>
  );
};

export default CardPost;
